// GLIM -- THE FACE of Martian. Personality, recognition, companion.
// Static mark. For product states use <GLIMState/>.
//
// Optical size ladder (locked): below GLIM_SIZE_LADDER.micro (28 px) the
// simplified body + sensor-slit cut is used so the face stays recognizable;
// everything else uses the full master. GLIM never becomes wallpaper and
// never competes with ARC in the same frame -- ONE LEAD PER FRAME.

import { GLIM_ASSETS, GLIM_SIZE_LADDER } from './assets';
import './brand.css';

const TONE_SRC = {
  clay: GLIM_ASSETS.master,
  'cream-on-ink': GLIM_ASSETS.creamOnInk,
  'mono-ink': GLIM_ASSETS.monoInk,
  'mono-paper': GLIM_ASSETS.monoPaper,
};

export function glimSource(size, tone = 'clay') {
  if (tone === 'clay' && size < GLIM_SIZE_LADDER.micro) return GLIM_ASSETS.micro;
  return TONE_SRC[tone] || GLIM_ASSETS.master;
}

export function GLIM({
  size = 64,
  tone = 'clay',
  decorative = false,
  label = 'Martian',
  className = '',
  ...rest
}) {
  return (
    <img
      src={glimSource(size, tone)}
      width={size}
      height={size}
      alt={decorative ? '' : label}
      aria-hidden={decorative ? 'true' : undefined}
      draggable={false}
      className={`glim ${className}`.trim()}
      data-testid="glim"
      data-tone={tone}
      {...rest}
    />
  );
}

export default GLIM;
